export type CountryCode = 'CA' | 'US';

export type ProvinceCode =
  'BC' | 'ON' | 'AB' | 'MB' | 'NB' | 'NL' | 'NT' | 'NS' | 'NU' | 'PE' | 'QC' | 'SK' | 'YK' ;

export type ProvincialTax = {
  readonly province: ProvinceCode
  readonly tax: number
};

export const ProvincialTaxes: ProvincialTax[] = [
  {province: 'AB', tax: 5},
  {province: 'BC', tax: 12},
  {province: 'MB', tax: 13},
  {province: 'NB', tax: 15},
  {province: 'NL', tax: 15},
  {province: 'NT', tax: 5},
  {province: 'NS', tax: 15},
  {province: 'NU', tax: 5},
  {province: 'ON', tax: 13},
  {province: 'PE', tax: 15},
  {province: 'QC', tax: 14.975},
  {province: 'SK', tax: 11},
  {province: 'YK', tax: 5}
];

export interface CountryInfo {
  code: CountryCode;
  name: string;
}

export interface ProvinceInfo {
  country: CountryCode;
  code: ProvinceCode;
  name: string;
}



// WEBPACK FOOTER //
// ./src/geo/geo.types.tsx